import i18next from 'i18next';
import type { EurotaxBackfillVehicle } from '../types';
import { migrationDebugOf, statusLabelOf } from './vehicleStatus';

export function exportTimestamp(date = new Date()): string {
	const pad = (value: number, length = 2) =>
		String(value).padStart(length, '0');

	return [
		date.getFullYear(),
		pad(date.getMonth() + 1),
		pad(date.getDate()),
		'_',
		pad(date.getHours()),
		pad(date.getMinutes()),
		pad(date.getSeconds()),
		pad(date.getMilliseconds(), 3),
	].join('');
}

export function buildExportData(
	vehicles: EurotaxBackfillVehicle[]
): (string | number)[][] {
	const t = (key: string, fallback: string) => i18next.t(key, fallback);

	const headers = [
		t('motornet_backfill_platform_id', 'Platform id'),
		i18next.t('marca'),
		i18next.t('modello'),
		i18next.t('allestimento'),
		t('motornet_backfill_manufacturer_code_jato', 'Cod. costruttore Jato'),
		t(
			'motornet_backfill_manufacturer_code_motornet',
			'Cod. costruttore Motornet'
		),
		t('motornet_backfill_jato_id', 'JATO id'),
		t('motornet_backfill_status', 'Stato'),
		t('motornet_backfill_debug_retries', 'Tentativi'),
		t('motornet_backfill_debug_kinds', 'Tipologie provate'),
		t('motornet_backfill_debug_message', 'Messaggio'),
		t('motornet_backfill_debug_processed_at', 'Processato il'),
	];

	const rows = vehicles.filter(Boolean).map((vehicle) => {
		const debug = migrationDebugOf(vehicle);

		return [
			vehicle.platform_uuid,
			vehicle.marca ?? '',
			vehicle.modello ?? '',
			vehicle.allestimento ?? '',
			vehicle.codice_costruttore ?? '',
			vehicle.manufacture_code ?? '',
			vehicle.jato_id ?? '',
			statusLabelOf(vehicle, t),
			debug?.retry_count ?? '',
			debug?.vehicle_kinds_tried?.join(', ') ?? '',
			debug?.message ?? '',
			debug?.processed_at
				? new Date(debug.processed_at).toLocaleString('it-IT')
				: '',
		];
	});

	return [headers, ...rows];
}
